import {
  InfoBlock,
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableHeader,
  Input
} from '../../../../styles/component.styles';

const FulfillmentItemSelector = ({
  orderItems = [],
  quantities = {},
  onQuantityChange = () => {},
  disabled = false
}) => {
  return (
    <InfoBlock>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Product</TableHead>
            <TableHead>SKU</TableHead>
            <TableHead>Size</TableHead>
            <TableHead>Total</TableHead>
            <TableHead>Fulfilled</TableHead>
            <TableHead>Remaining</TableHead>
            <TableHead>To Fulfill</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {orderItems.map((item, idx) => {
            const current = quantities[item.orderItemId] ?? item.remaining;

            return (
              <TableRow key={idx}>
                <td>{item.productName || '—'}</td>
                <td>{item.sku || '—'}</td>
                <td>{item.size || '—'}</td>
                <td>{item.total}</td>
                <td>{item.fulfilled}</td>
                <td>{item.remaining}</td>
                <td>
                  <Input
                    type="number"
                    min={0}
                    max={item.remaining}
                    value={current}
                    disabled={disabled || item.remaining === 0}
                    onChange={(e) =>
                      onQuantityChange(
                        item.orderItemId,
                        Math.max(0, Math.min(item.remaining, Number(e.target.value)))
                      )
                    }
                    style={{ width: '70px' }}
                  />
                </td>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </InfoBlock>
  );
};

export default FulfillmentItemSelector;